export default __webpack_public_path__ + "static/media/paintIcon.658114c2.svg";